import vcCheckbox from './src/vc-checkbox'

vcCheckbox.install = function (Vue) {
  Vue.component(vcCheckbox.name, vcCheckbox)
}

export default vcCheckbox
